export const Auth_URL = process.env.REACT_APP_API_LOGIN;
export const CommonListing_URL = process.env.REACT_APP_COMMONLISTING;
export const Access_Management_CommonListing_URL =
  process.env.REACT_APP_ACCESS_COMMONLISTING;
export const Column_URL = process.env.REACT_APP_COLUMN_SERVICE_IP_API;
export const User_Service_URL = process.env.REACT_APP_USER_SERVICE;
export const Lead_Service_URL = process.env.REACT_APP_LEAD_SERVICE;
export const Branch_Contact_URL = process.env.REACT_APP_BRANCH_CONTACT;
export const Branch_Location_Pincode_URL =
  process.env.REACT_APP_BRANCH_LOCATION_PINCODE;
export const Branch_Gst_Verification_URL =
  process.env.REACT_APP_BRANCH_GST_VERIFICATION;
export const System_URL = process.env.REACT_APP_API_SYSTEM;
export const Partner_Service_URL = process.env.REACT_APP_PARTNER_SERVICE;
export const Location_Service_URL = process.env.REACT_APP_LOCATION_SERVICE;
export const Master_Service_URL = process.env.REACT_APP_MASTER_SERVICE;
export const Master_Service_TEAMS_URL =
  process.env.REACT_APP_MASTER_SERVICE_TEAMS;
export const Documents_Master_Service_URL =
  process.env.REACT_APP_API_DOCUMENTS_SERVICE;
export const Import_Lead_URL = process.env.REACT_APP_IMPORT_LEAD;
export const Lead_Allocation_Service = process.env.REACT_APP_LEAD_ALLOCATION
export const Applicant_Service = process.env.REACT_APP_APPLICANT_SERVICE
export const Payout_Service = process.env.REACT_APP_PAYOUT_SERVICE;
export const s3BucketName = process.env.REACT_APP_S3_BUCKET_NAME;
export const s3File_Service = process.env.REACT_APP_S3_FILE_SERVICE;
export const GA_KEY = process.env.REACT_APP_GA_KEY;
export const OTP_SERVICE = process.env.REACT_APP_OTP_SERVICE;
export const regen_payout_V = process.env.REACT_APP_REGEN_PAYOUT_V
console.log('line 24', process.env)
